<template>
  <div class="container-fluid Loading">
    <div class="centerBox container">
      <div class="row">
        <div class="col-12">
          <div class="row mt-5 pt-6">
            <div class="col-2 text-center"></div>
            <div class="col-2 pt-2 text-center">
              <Spinner fadeIn="quarter" name="cube-grid" height="75" width="75" color="#5CB0FF" />
            </div>
            <div class="col-8 mt-5">
              <h4 class="text-secondary">در حال بارگذاری</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style scoped>
.Loading {
  width: 100vw !important;
  height: 100vh !important;
  position: absolute !important;
  top: 0;
  background: #92a5e28e;
  z-index: 5258585;
  padding: 0 !important;
}
.centerBox {
  width: 25vw !important;
  height: 25vh !important;
  border-radius: 15px;
  margin: auto;
  top: 37%;
  position: relative;
  background-color: #29323a;
}
.text {
  background-color: var(--logo-color);
  color: var(--logo-color);
}
</style>
